<div class="card w-100 form-right call-panel-card">
  <div class="back">
    <h2 *ngIf="!selectedCall">{{ "call_panel.title" | translate }}</h2>
    <h2 *ngIf="selectedCall">{{ "communication.voip.call_history" | translate }}</h2>
    <i *ngIf="selectedCall" class="icon-arrow-left back-btn" (click)="closeCallDetail()"></i>
    <i *ngIf="!selectedCall" class="icon-cross2" (click)="close()"></i>
  </div>

  <!-- Call Detail View -->
  <div *ngIf="selectedCall" class="call-detail-wrapper">
    <app-call-detail
      [call]="selectedCall"
      (close)="closeCallDetail()">
    </app-call-detail>
  </div>

  <!-- Loading detail -->
  <div *ngIf="selectedCallLoading && !selectedCall" class="text-center py-4">
    <div class="spinner-border text-primary" role="status"></div>
  </div>

  <!-- Main Panel (hidden when detail is open) -->
  <div class="card-body call-panel-body" *ngIf="!selectedCall && !selectedCallLoading">
    <!-- Contact info -->
    <div class="call-contact-info">
      <div class="contact-avatar" [style.borderColor]="getStateColor()">{{ contactInitial }}</div>
      <h3 class="contact-name">{{ contactName || ("call_panel.unknown" | translate) }}</h3>
      <p class="phone-display">{{ phoneNumber }}</p>

      <!-- Call status -->
      <div class="call-status" *ngIf="callState !== 'idle'">
        <span class="call-state-label" [style.color]="getStateColor()">
          {{ getStateLabel() | translate }}
        </span>
        <span class="call-timer" *ngIf="callState === 'in-call' || callState === 'ended'">
          {{ formatDuration(callDuration) }}
        </span>
        <span class="call-pulse" *ngIf="callState === 'dialing' || callState === 'ringing'"></span>
      </div>
    </div>

    <!-- Actions -->
    <div class="call-actions">
      <button *ngIf="!isCallActive"
        class="btn btn-success btn-call"
        type="button"
        [disabled]="!phoneNumber"
        (click)="initiateCall()"
      >
        <i class="icon-telephone"></i>
        {{ "call_panel.start_call" | translate }}
      </button>
      <button *ngIf="isCallActive"
        class="btn btn-danger btn-call"
        type="button"
        (click)="hangupCall()"
      >
        <i class="icon-telephone"></i>
        {{ "call_panel.hangup" | translate }}
      </button>
    </div>

    <!-- Client Call History -->
    <div class="client-calls-section" *ngIf="clientReference">
      <div class="client-calls-header">
        <i class="icon-history"></i>
        <span class="client-calls-title">
          {{ 'communication.voip.client_calls_title' | translate }}
          <span class="badge badge-secondary ms-1" *ngIf="clientCallsLoaded">
            {{ clientCallsTotal }}
          </span>
        </span>
      </div>

      <!-- Loading -->
      <div *ngIf="clientCallsLoading && clientCalls.length === 0" class="text-center py-2">
        <div class="spinner-border spinner-border-sm text-info" role="status"></div>
      </div>

      <!-- Error -->
      <div *ngIf="clientCallsError" class="text-center py-2 text-muted">
        <small>{{ 'communication.voip.client_calls_error' | translate }}</small>
        <button class="btn btn-link btn-sm" (click)="loadClientCalls()">
          {{ 'communication.voip.client_calls_retry' | translate }}
        </button>
      </div>

      <!-- Empty -->
      <div *ngIf="clientCallsLoaded && !clientCallsLoading && !clientCallsError && clientCalls.length === 0" class="text-center py-2">
        <small class="text-muted">{{ 'communication.voip.client_calls_empty' | translate }}</small>
      </div>

      <!-- Calls list -->
      <div class="client-calls-list" *ngIf="clientCalls.length > 0">
        <div class="client-call-item clickable" *ngFor="let call of clientCalls" (click)="openCallDetail(call)">
          <!-- Row 1: direction, date, duration, status badge, arrow -->
          <div class="client-call-row">
            <span class="call-direction"
              [ngClass]="{
                'text-success': call.status === 'answered',
                'text-danger': call.status === 'missed',
                'text-muted': call.status !== 'answered' && call.status !== 'missed'
              }">
              <i [class]="call.direction === 'outbound' ? 'icon-call-outgoing' : 'icon-call-incoming'"></i>
            </span>
            <span class="call-date">{{ call.started_at || call.created_at | date:'dd/MM HH:mm' }}</span>
            <span class="call-status-badge badge"
              [ngClass]="{
                'bg-success': call.status === 'answered',
                'bg-danger': call.status === 'missed' || call.status === 'failed',
                'bg-warning': call.status === 'busy',
                'bg-secondary': call.status === 'canceled',
                'bg-info': call.status === 'initiated'
              }">
              {{ 'communication.voip.status_' + call.status | translate }}
            </span>
            <span class="call-duration" *ngIf="call.duration">{{ formatCallDuration(call.duration) }}</span>
            <i class="icon-chevron-right call-detail-arrow"></i>
          </div>

          <!-- Row 2: disposition + recording/transcript icons -->
          <div class="client-call-meta" *ngIf="call.disposition || call.has_recording || call.agent">
            <span class="call-disposition badge" *ngIf="call.disposition"
              [ngClass]="{
                'badge-success': call.disposition === 'interested' || call.disposition === 'deal_closed',
                'badge-warning': call.disposition === 'callback' || call.disposition === 'follow_up',
                'badge-danger': call.disposition === 'not_interested' || call.disposition === 'complaint',
                'badge-secondary': call.disposition !== 'interested' && call.disposition !== 'deal_closed' && call.disposition !== 'callback' && call.disposition !== 'follow_up' && call.disposition !== 'not_interested' && call.disposition !== 'complaint'
              }">
              {{ 'communication.voip.disposition_' + call.disposition | translate }}
            </span>
            <span class="badge badge-recording" *ngIf="call.has_recording">
              <i class="icon-mic"></i> {{ 'communication.voip.recording' | translate }}
            </span>
            <span class="badge badge-transcript" *ngIf="call.transcript_status === 'completed'">
              <i class="icon-text"></i> {{ 'communication.voip.transcription' | translate }}
            </span>
            <span class="call-agent" *ngIf="call.agent">
              <i class="icon-user"></i> {{ call.agent.name }}
            </span>
          </div>

          <!-- Row 3: notes -->
          <div class="client-call-notes" *ngIf="call.notes">
            <small class="text-muted" [title]="call.notes">
              <i class="icon-notebook"></i>
              {{ call.notes.length > 80 ? (call.notes | slice:0:80) + '...' : call.notes }}
            </small>
          </div>

          <!-- Row 4: tags -->
          <div class="client-call-tags" *ngIf="call.tags && call.tags.length > 0">
            <span class="badge badge-light-soft me-1" *ngFor="let tag of call.tags">{{ tag }}</span>
          </div>
        </div>

        <!-- Load more -->
        <div *ngIf="hasMoreClientCalls && !clientCallsLoading" class="text-center py-1">
          <button class="btn btn-link btn-sm" (click)="loadMoreClientCalls()">
            {{ 'communication.voip.client_calls_load_more' | translate }}
          </button>
        </div>
        <div *ngIf="clientCallsLoading && clientCalls.length > 0" class="text-center py-1">
          <div class="spinner-border spinner-border-sm text-info" role="status"></div>
        </div>
      </div>
    </div>
  </div>
</div>
